import { oc } from '@orpc/contract';
import { z } from 'zod';
import { commonErrors } from './errors.js';

export const organizationBrandingContract = oc
  .route({ method: 'GET', path: '/organization-branding' })
  .errors({ NOT_FOUND: commonErrors.NOT_FOUND, TOO_MANY_REQUESTS: commonErrors.TOO_MANY_REQUESTS })
  .input(z.object({}))
  .output(
    z.object({
      organizationName: z.string().nullable(),
      logoUrl: z.string().nullable(),
      siteKind: z.enum(['admin', 'portal']).nullable(),
    }),
  );
